import * as api from '../../requests'
import {
  CLEAR_BO_SEARCH_ERRORS,
  SET_BO_SEARCH_PARAMETERS,
  SET_LAST_SEARCH_INFO,
  SET_MISC_SEARCH_TEMPLATE,
  SET_PAGINATED_ROW_COUNTS,
} from './BOSearchReducer'

export const setSearchParameters = (searchParameters) => ({
  type: SET_BO_SEARCH_PARAMETERS,
  searchParameters,
})

export const setBOSearchResults = (items, searchName) => ({
  type: 'SET_BO_SEARCH_RESULTS',
  items,
  searchName,
})

export const setBOCSVSearchResults = (items, searchName) => ({
  type: 'SET_BO_CSV_SEARCH_RESULTS',
  items,
  searchName,
})

export const setLastSearchInfo = (lastSearchName, lastUsedParameters) => ({
  type: SET_LAST_SEARCH_INFO,
  lastSearchName,
  lastUsedParameters,
})

export const fetchAndSetBOSearchResults =
  (payload, searchName, searchTitle, callback, errorCallback) => (dispatch) => {
    dispatch(setSearchParameters(payload))
    dispatch({ type: CLEAR_BO_SEARCH_ERRORS })
    api.BO_SEARCH(
      payload,
      searchName,
      (response) => {
        dispatch(setBOSearchResults(response, searchTitle))
        dispatch(setLastSearchInfo(searchName, payload))
        if (callback) callback(response)
      },
      (err) => {
        if (errorCallback) errorCallback(err)
        dispatch(setWorkviewError(true))
        dispatch(setWorkviewErrorDetails(err))
      }
    )
  }

export const checkDLNValid = (dln, callback, error) => {
  api.GET_ENVELOPE_ID_BY_DLN(dln, (response) => {
    if (response.EnvelopeID && response.EnvelopeID !== 0) {
      if (callback) callback(response.EnvelopeID)
    } else {
      if (error) error(dln)
    }
  })
}

export const fetchAndSetDLNSearchResults =
  (dln, searchTitle, callback, errorCallback) => (dispatch) => {
    api.GET_ENVELOPE_ID_BY_DLN(
      dln,
      (response) => {
        if (response.EnvelopeID && response.EnvelopeID !== 0) {
          const envelopeId = response.EnvelopeID
          api.GET_IMAGE_BY_DLN(
            dln,
            (envelope) => {
              const group = envelope?.groups?.[0]
              if (!group) {
                if (errorCallback) errorCallback(dln)
                return
              }
              const row = {
                DLN: dln,
                Document: group.name,
                Status: group.status,
                'Entry Type': group.entryType,
                Pages: group.pages.length,
                SourceID: envelopeId,
              }
              dispatch(setBOSearchResults([row], searchTitle))
              if (callback) callback(envelopeId)
            },
            () => {
              if (errorCallback) errorCallback(dln)
            }
          )
        } else {
          if (errorCallback) errorCallback(dln)
        }
      },
      () => {
        if (errorCallback) errorCallback(dln)
      }
    )
  }

export const setMiscSearchTemplate = (searchTitle, template) => ({
  type: SET_MISC_SEARCH_TEMPLATE,
  searchTitle,
  template,
})

export const fetchAndSetMiscBOSearchResults =
  (payload, searchTitle, callback, errorCallback) => (dispatch) => {
    dispatch({ type: CLEAR_BO_SEARCH_ERRORS })
    api.GET_MISC_STAFF_SEARCH(
      payload,
      (response) => {
        dispatch(setBOSearchResults(response.Results, searchTitle))
        dispatch(setMiscSearchTemplate(searchTitle, response.Template))
        dispatch({ type: SET_PAGINATED_ROW_COUNTS, searchName: searchTitle, rowCount: response.TotalCount })
        if (callback) callback()
      },
      (err) => {
        dispatch(setWorkviewError(true))
        dispatch(setWorkviewErrorDetails(err))
        if (errorCallback) errorCallback()
      }
    )
  }

export const setWorkviewError = (error) => ({
  type: 'SET_BO_SEARCH_ERROR',
  error,
})

export const setWorkviewErrorDetails = (errorDetails) => ({
  type: 'SET_BO_SEARCH_ERROR_DETAILS',
  errorDetails,
})
